import { render, staticRenderFns } from "./Acti.vue?vue&type=template&id=ba947320&scoped=true"
import script from "./Acti.vue?vue&type=script&lang=js"
export * from "./Acti.vue?vue&type=script&lang=js"
import style0 from "./Acti.vue?vue&type=style&index=0&id=ba947320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba947320",
  null
  
)

export default component.exports